// Utility functions for user management

/**
 * Get the logged-in user ID from localStorage
 * Returns the user ID if persona is not 'retailer', otherwise returns null
 */
export const getLoggedInUser = (): string | null => {
  return localStorage.getItem('loggedInUser');
};

/**
 * Set the logged-in user ID in localStorage
 * Should be called when persona is not 'retailer'
 */
export const setLoggedInUser = (userId: string): void => {
  localStorage.setItem('loggedInUser', userId);
};

/**
 * Clear the logged-in user ID from localStorage
 * Should be called when persona is 'retailer'
 */
export const clearLoggedInUser = (): void => {
  localStorage.removeItem('loggedInUser');
};

/**
 * Check if there is a logged-in user
 */
export const hasLoggedInUser = (): boolean => {
  return getLoggedInUser() !== null;
};
